import { BaseService } from 'hungry-core2'

import actions from '@actions'

export default class Dashboard extends BaseService {
  toggleLoading = (on) => this.dispatch(actions.toggleDashboardLoading(on))
}
